<template>
    <div class="locations-app">
      <section class="locations_grid main-container mb-5">
        <div class="__left">
            <LocationsCTAs></LocationsCTAs>
        </div>
        <div class="__right">
            <LocationsMap></LocationsMap>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import LocationsCTAs from '@components/locations/LocationsCTAs.vue';
  import LocationsMap from '@components/locations/LocationsMap.vue';
  
  export default {
    name: 'App',
    components: {
      LocationsCTAs,
      LocationsMap
    }
  };
  </script>
  
  <style scoped>
    .main-container{
      min-height: auto !important;
    }
  </style>
  <style lang="scss">
  .locations_grid{
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
    flex-wrap: nowrap;
    @media (max-width:768px) {
      flex-direction: column-reverse;
      margin-top: -36%;
    }
    .__left{
        flex: 1;
        @media (max-width: 768px) {
          text-align: center;
          .locations-ctas{
            max-width: 100% !important;
          }
        }
    }

    .__right{
        flex: 3;
        max-width: 65%;
        width: 100%;
        @media (max-width:768px) {
          margin-bottom: 30px;
        }
    }
  }

  @media (max-width: 768px) {
    .banner-cta {
        background-color: #005f73; /* Adjust the background color as needed */
        min-width: 100%;
        aspect-ratio: 16/16;
        max-height: 600px;
        padding-block: 40px;
        text-align: left;
        display: flex;
        align-items: center;
        position: relative;
        margin-top: -80px;
        background-size: cover;
        background-repeat: no-repeat;
        .main-container {
            display: flex;
            align-items: center;
        }
        .__content {
            color: #fff;
            max-width: 50%;
            display: flex;
            flex-direction: column;
            margin-top: 30px;
            >h2 {
                font-size: 30px;
                font-weight: 600;
                margin-bottom: 1rem;
                line-height: 40px;
            }
        }
    }
    .locations_grid{
        flex-wrap: wrap;
        .__left, .__right{
            min-width: 260px;
        }
        .__right{
            max-width: 100%;
            min-width: 260px;
        }
    }
  }
  
  </style>
  